import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { CompleteBookingComponent } from './pages/complete-booking/complete-booking.component';
import { DeleteCompletedComponent } from './pages/delete-completed/delete-completed.component';
import { EditBookingComponent } from './pages/edit-booking/edit-booking.component';
import { EventListComponent } from './pages/event-list/event-list.component';
import { HomeLandingComponent } from './pages/landing/home-landing/home-landing.component';
import { LoginLandingComponent } from './pages/landing/login-landing/login-landing.component';
import { NotAllowedComponent } from './pages/landing/not-allowed/not-allowed.component';
import { PreLandingComponent } from './pages/landing/pre-landing/pre-landing.component';
import { SelectUsersComponent } from './pages/select-users/select-users.component';
import { SummaryComponent } from './pages/summary/summary.component';
import { ROUTES } from './route/routes';
import { HandleReservationsComponent } from './pages/handle-reservations/handle-reservations.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { MessagesComponent } from './pages/landing/messages/messages.component';
import { ReservationComponent } from './pages/reservation/reservation.component';
import { HomeCategoryComponent } from './pages/landing/home-category/home-category.component';

const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: ROUTES.HOME.path,
        component: HomeLandingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_HOME.path,
        component: HomeCategoryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_LIST.path,
        component: EventListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_SELECT_PROFILE.path,
        component: SelectUsersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_CALENDAR.path,
        component: CalendarComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_SUMMARY.path,
        component: SummaryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_CONFIRMATION.path,
        component: CompleteBookingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_EDIT.path,
        component: EditBookingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_EVENT_DELETE.path,
        component: DeleteCompletedComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_RESERVATION_LIST.path,
        component: HandleReservationsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ROUTES.FLUX_RESERVATION.path,
        component: ReservationComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: ROUTES.PRE_LANDING.path,
    component: PreLandingComponent,
    canActivate: [],
  },
  {
    path: ROUTES.NOT_ALLOWED.path,
    component: NotAllowedComponent,
    canActivate: [],
  },
  {
    path: ROUTES.MESSAGE.path,
    component: MessagesComponent,
    canActivate: [],
  },
  {
    path: ROUTES.LOGIN.path,
    component: LoginLandingComponent,
    canActivate: [],
  },
  { path: '**', redirectTo: '/not-allowed' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
